define([
	"dojo/_base/declare",
	"csi/table/Widget",
	"csi/view/ToolbarFind",
	"./ExportCoverageStores"
], function(declare,Table,ToolbarFind,ExportCoverageStores) {

	return declare(Table, {
		disableCustomViewToolbar: true,
		findAttributes: ["Node Name","ExportClassLocalized","ExportClassReachableTo","ExportClassReachableFrom"],
		plugins: ["find","tableExcel"],
		pluginsRight: [],
		prefClass: null,
		store: ExportCoverageStores.Out,
		bResetStore: false
	});
});